import { executeRequest, Request, Response } from '@jfs/network'
import { getAPIURL, getMMSHeader } from '../config'

const responseParser = (response: Response) => {
  const result = response?.status
    ? response?.data
    : response?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.channelDesc ??
    response?.data?.errors?.[0]?.exception?.message ??
    response?.data?.errors?.[0]?.message
  if (typeof result === 'object') {
    const { businessName, businessProfile, terminalDetails, entityConfigs, entityConfigList, cardDetails }: any =
      result ?? {}
    const filteredAcceptedPayments = entityConfigs?.filter(
      (payment: any) =>
        payment?.configType === ('PAYMENT_ACCEPTANCE' || payment?.configType === 'SAVE_CARD') && payment?.value === 'Y',
    )
    const ALLOWED_TXN_TYPE = entityConfigList?.filter((payment: any) => payment?.key === 'ALLOWED_TXN_TYPE')
    let paymentModes = filteredAcceptedPayments?.map((card: any) => card?.key)
    if (ALLOWED_TXN_TYPE?.length) {
      const added = ALLOWED_TXN_TYPE.map((item: any) => item?.value)
      paymentModes = [...paymentModes, ...added]
    }
    const EMI_CONFIG = entityConfigs?.find((emi: any) => emi?.configType === 'EMI_CONFIG' && emi?.key === 'EMI_MIN_AMT')
    const ALLOWED_RETRIES = entityConfigs?.find(
      (payment: any) => payment?.configType === 'ALLOWED_RETRIES' && payment?.key === 'RETRY_COUNT',
    )

    const allowedCards = cardDetails?.map((card: any) => ({
      scheme: card?.cardScheme,
      type: card?.cardType,
      isDomesticAllowed: card?.domesticAllowed,
      isInternationalAllowed: card?.internationalAllowed,
      isPremium: card?.premium,
    }))

    const primaryAccount = terminalDetails?.find((merchant: any) => merchant.primary)
    const retData = {
      name: businessName ?? '',
      mcc: businessProfile.mccCode ?? '',
      vpa: primaryAccount?.vpaLinkingDetails?.handle ?? '',
      configValues: paymentModes?.join('|'),
      emiMinAmount: EMI_CONFIG?.value ?? '1500',
      upiRetriesCount: ALLOWED_RETRIES?.value ?? '3',
      allowedCards,
    }
    return retData
  } else {
    throw { message: result }
  }
}

export const searchEntity = async (input: any) => {
  const request: Request<{}> = {
    apiPath: `${getAPIURL('searchEntity')}`,
    method: 'POST',
    headers: getMMSHeader(),
    body: input,
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error: any) => {
      throw error
    })
}
